// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HM9S","question":"styles_question__m54fy","inputVisibleButton":"styles_inputVisibleButton__3BJOb","note":"styles_note__2LxAV"};